import {
  connection,
  deleteRecord,
  findRecord,
  insertRecord,
  transferMoney,
  updateRecord,
  updateWalletsForTransfer,
} from "./services";
import { showSwalError } from "../utilities/swal";
import axios from "axios";
import Cookie from "js-cookie";


const AllOrders=async()=>{
    let res = await  connection("getmyfactors",{});
    return res;
}

export { AllOrders };